import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { AlertSeverityEnum, UseMutationsParams } from '@/shared/interfaces';
import {
  IUbicacionesPagingRes,
  Ubicaciones,
} from '@/shared/interfaces/erp/inventario';
import { useUiStore } from '@/store/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchUbicaciones = (
  params?: GetUbicacionesParams,
  enabled = true
) => {
  return useQuery({
    queryKey: ['ubicaciones', ...Object.values(params ?? {})],
    queryFn: async () => {
      return getUbicaciones(params);
    },
    enabled,
  });
};

export const useGetUbicacion = (id: string) => {
  return useQuery({
    queryKey: ['Ubicaciones', id],
    queryFn: async () => {
      return getUbicacion(id);
    },
  });
};

export const useCreateUbicaciones = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createUbicaciones,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Ubicaciones'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Ubicación creada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateUbicaciones = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updateUbicaciones,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Ubicaciones'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Ubicación actualizada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

///* axios
export type GetUbicacionesParams = Partial<Ubicaciones> & {
  page?: number;
  page_size?: number;
  nombre?: string;
  bodega?: string | null;
  ubicacion?: string;
  bodega_codigo?: string;
  filterByState?: boolean;
  estado?: boolean;
  bodega_externa?: boolean;
  codigo_in?: string
};

export type CreateUbicacionesParams = Omit<Ubicaciones, 'id_ubicacion'>;
export type UpdateUbicacionesParams = {
  id: string;
  data: CreateUbicacionesParams;
};

export const getUbicaciones = async (params?: GetUbicacionesParams) => {
  const stateParams = { ...params };

  // filterByState
  if (stateParams.filterByState === false && stateParams.estado === undefined) {
    delete stateParams.estado;
  } else if (stateParams.filterByState !== false) {
    stateParams.estado = true;
  }
  delete stateParams.filterByState;

  const queryParams = getUrlParamsFetch(stateParams);

  return get<IUbicacionesPagingRes>(
    `${urlBackend}api/v1/ubicacion/?${queryParams}`,
    true
  );
};

export const getUbicacion = async (id: string) => {
  try {
    return await get<Ubicaciones>(`${urlBackend}api/v1/ubicacion/${id}/`, true);
  } catch (error) {
    return handleAxiosError(error);
  }
};

export const createUbicaciones = async (data: CreateUbicacionesParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);
  return post<Ubicaciones>(`${urlBackend}api/v1/ubicacion/`, data, true);
};

export const updateUbicaciones = async ({
  id,
  data,
}: UpdateUbicacionesParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<Ubicaciones>(`${urlBackend}api/v1/ubicacion/${id}/`, data, true);
};




/* export const fetchAutocompleteUbicacion = async (
  searchValue: string,
  page: number,
  params?: any
): Promise<{ options: Ubicaciones[]; hasMore: boolean }> => {
  const query = getUrlParamsFetch({
    ...params,
    estado: true,
    nombre: searchValue,
    page,
  });

  const response = await get<IUbicacionesPagingRes>(`${urlBackend}api/v1/ubicacion/?${query}`, true);

  return {
    options: response.data.data,
    hasMore: true,
  };
}; */